<mat-card class="detail-card" valumizeCardContextMenu [commentSlug]="'deal-cashflows-graph'" [cardChartSource]="cardChartSource">
  <valumize-card-comments-button [commentSlug]="'deal-cashflows-graph'"></valumize-card-comments-button>
  @if (!isSensitivityView) {
    <mat-expansion-panel [expanded]="graphPanelOpenState" class="mat-expansion-panel">
      <mat-expansion-panel-header class="mat-expansion-panel-header">
        <mat-card-title data-test="title">Deal Cashflows Graph</mat-card-title>
      </mat-expansion-panel-header>

      @if ((dealCashflowsGraph$ | async); as graphData) {
        <div class="chart-container" [class.hidden]="!hasAggregateGraphData(graphData)">
          <canvas id="DealCashflowsGraph"></canvas>
        </div>
        @if (!hasAggregateGraphData(graphData)) {
          <div class="detail-card-content" style="color: grey">
            Unable to display cashflow graph. Please ensure all required deal details, including carry rate and hurdle rate, are provided.
          </div>
        }
      }
    </mat-expansion-panel>
  }

  <mat-expansion-panel [expanded]="scenarioGraphPanelOpenState" class="mat-expansion-panel">
    <mat-expansion-panel-header class="mat-expansion-panel-header">
      <mat-card-title data-test="title">Scenario Cashflows Graphs</mat-card-title>
    </mat-expansion-panel-header>

    <mat-card-content class="detail-card-content">
      <mat-tab-group selectedIndex="0">
        <mat-tab label="Weighted" data-test="tab-weighted">
          @if ((weightedScenarioCashflowsGraph$ | async); as weightedGraphData) {
            <div class="chart-container" [class.hidden]="!hasGraphData(weightedGraphData)">
              <canvas id="WeightedScenarioCashflowsGraph"></canvas>
            </div>
            @if (!hasGraphData(weightedGraphData)) {
              <div class="detail-card-content" style="color: grey">
                Unable to display cashflow graph. Please ensure all required deal details, including carry rate and hurdle rate, are provided.
              </div>
            }
          }
        </mat-tab>
        <mat-tab label="Low" data-test="tab-low">
          @if ((lowScenarioCashflowsGraph$ | async); as lowGraphData) {
            <div class="chart-container" [class.hidden]="!hasGraphData(lowGraphData)">
              <canvas id="LowScenarioCashflowsGraph"></canvas>
            </div>
            @if (!hasGraphData(lowGraphData)) {
              <div class="detail-card-content" style="color: grey">
                Unable to display cashflow graph. Please ensure all required deal details, including carry rate and hurdle rate, are provided.
              </div>
            }
          }
        </mat-tab>
        <mat-tab label="Base" data-test="tab-base">
          @if ((baseScenarioCashflowsGraph$ | async); as baseGraphData) {
            <div class="chart-container" [class.hidden]="!hasGraphData(baseGraphData)">
              <canvas id="BaseScenarioCashflowsGraph"></canvas>
            </div>
            @if (!hasGraphData(baseGraphData)) {
              <div class="detail-card-content" style="color: grey">
                Unable to display cashflow graph. Please ensure all required deal details, including carry rate and hurdle rate, are provided.
              </div>
            }
          }
        </mat-tab>
        <mat-tab label="High" data-test="tab-high">
          @if ((highScenarioCashflowsGraph$ | async); as highGraphData) {
            <div class="chart-container" [class.hidden]="!hasGraphData(highGraphData)">
              <canvas id="HighScenarioCashflowsGraph"></canvas>
            </div>
            @if (!hasGraphData(highGraphData)) {
              <div class="detail-card-content" style="color: grey">
                Unable to display cashflow graph. Please ensure all required deal details, including carry rate and hurdle rate, are provided.
              </div>
            }
          }
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-expansion-panel>
</mat-card>
